import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./TakeoverHeader.css";

export default function TakeoverHeader({ children, className }) {
  return <h1 className={classNames(styles.root, className)}>{children}</h1>;
}

TakeoverHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
